const initialState = 0;

export default (state: number = initialState, action: any): number =>
    action.type.startsWith("BEGIN_") ? state + 1 : action.type.startsWith("END_") ? state - 1 : state;
